

import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';

@Component({
  selector: 'app-rto-demand-management',
  templateUrl: './rto-demand-management.component.html',
  styleUrls: ['./rto-demand-management.component.css']
})
export class RtoDemandManagementComponent implements OnInit, OnDestroy {

  public destroyed = new Subject<any>();

  constructor() {

  }
  ngOnInit(): void {

  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
